import {
  Avatar as AvatarShadcn,
  AvatarFallback as AvatarFallbackShadcn,
  AvatarImage as AvatarImageShadcn,
} from '@/components/ui/avatar';
import { Avatar as AvatarType } from '@/routes/_dashboard/avatar';
import Avatar from '@/avatar';
import { optionTypes } from '@/avatar/options/types';

interface CustomAvatarProps {
  width?: string;
  height?: string;
  avatarString?: string | null;
  image?: string | null;
  name: string;
}

const CustomAvatar = ({
  width = '40px',
  height = '40px',
  avatarString,
  image,
  name,
}: CustomAvatarProps) => {
  const parsedAvatar: AvatarType | null =
    typeof avatarString === 'string' ? JSON.parse(avatarString) : null;

  return (
    <div
      style={{ width, height }}
      className="flex items-center justify-center rounded-full"
    >
      {parsedAvatar ? (
        <Avatar
          style={{ width, height }}
          avatarStyle="Circle"
          topType={parsedAvatar.topType as optionTypes['topType']}
          accessoriesType={
            parsedAvatar.accessoriesType as optionTypes['accessoriesType']
          }
          facialHairType={
            parsedAvatar.facialHairType as optionTypes['facialHairType']
          }
          hatColor={parsedAvatar.hatColor as optionTypes['hatColor']}
          hairColor={parsedAvatar.hairColor as optionTypes['hairColor']}
          facialHairColor={
            parsedAvatar.facialHairColor as optionTypes['facialHairColor']
          }
          mouthType={parsedAvatar.mouthType as optionTypes['mouthType']}
          skinColor={parsedAvatar.skinColor as optionTypes['skinColor']}
          eyebrowType={parsedAvatar.eyebrowType as optionTypes['eyebrowType']}
          eyeType={parsedAvatar.eyeType as optionTypes['eyeType']}
          clotheType={parsedAvatar.clotheType as optionTypes['clotheType']}
          clotheColor={parsedAvatar.clotheColor as optionTypes['clotheColor']}
          graphicType={parsedAvatar.graphicType as optionTypes['graphicType']}
        />
      ) : (
        <AvatarShadcn>
          <AvatarImageShadcn
            style={{ width, height }}
            src={image ?? undefined}
            alt={name}
          />
          <AvatarFallbackShadcn
            style={{ width, height }}
            className="bg-pink-400 text-white"
          >
            {name.charAt(0).toUpperCase()}
          </AvatarFallbackShadcn>
        </AvatarShadcn>
      )}
    </div>
  );
};

export default CustomAvatar;
